"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var query_string_1 = __importDefault(require("query-string"));

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var redux_form_1 = require("redux-form");

var index_1 = require("../../index");

var initializeValues_1 = __importDefault(require("../../utils/initializeValues"));

var Form_1 = __importDefault(require("../Form"));

var ProgressBar_1 = __importDefault(require("./ProgressBar"));

var WizardSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var Wizard = function Wizard(_ref) {
  var backProps = _ref.backProps,
      className = _ref.className,
      id = _ref.id,
      pages = _ref.pages,
      name = _ref.name,
      params = _ref.params,
      progressProps = _ref.progressProps,
      progressItemProps = _ref.progressItemProps,
      progressItemIconProps = _ref.progressItemIconProps,
      _ref$progressShowStep = _ref.progressShowStep,
      progressShowStep = _ref$progressShowStep === void 0 ? false : _ref$progressShowStep,
      showProgress = _ref.showProgress;

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref2.sc;

  var dispatch = (0, react_redux_1.useDispatch)();

  var _ref3 = (0, react_1.useState)(0),
      _ref4 = _slicedToArray(_ref3, 2),
      page = _ref4[0],
      setPage = _ref4[1];

  var _ref5 = (0, react_1.useState)([]),
      _ref6 = _slicedToArray(_ref5, 2),
      infos = _ref6[0],
      setInfos = _ref6[1];

  var newPages = pages && !Array.isArray(pages) ? [pages] : pages;
  (0, react_1.useEffect)(function () {
    var newPage = 0;

    if (typeof window !== 'undefined' && window.location && window.location.search) {
      var search = {};
      window.location.search.slice(1).split('&').forEach(function (option) {
        var _option$split = option.split('='),
            _option$split2 = _slicedToArray(_option$split, 2),
            key = _option$split2[0],
            value = _option$split2[1];

        search[key] = value;
      });

      if (search.page) {
        newPage = parseInt(search.page, 10);
      }
    }

    setPage(newPage);
  }, []);
  (0, react_1.useEffect)(function () {
    if (newPages) {
      var newInfos = newPages.map(function (newPage, i) {
        return {
          inProgress: page === i,
          isConfirmed: false
        };
      });
      setInfos(newInfos);
    }
  }, [newPages, page]);

  var handleStepButtonOnClick = function handleStepButtonOnClick(event) {
    var i = event.currentTarget.getAttribute('data-page');

    if (i) {
      if (parseInt(i, 10) <= page) {
        setPage(parseInt(i, 10));
      } else {
        dispatch((0, redux_form_1.submit)(name));
      }
    }
  };

  var handleBackOnClick = function handleBackOnClick() {
    var newPage = Math.max(page - 1, 0);
    setPage(newPage);
    var location = window && window.location ? window.location.pathname : '/';
    location += "?page=".concat(newPage);
    window.history.replaceState({
      location: location,
      page: newPage
    }, "page ".concat(newPage), location);
  };

  var handleNextOnClick = function handleNextOnClick() {
    if (newPages) {
      var newPage = Math.min(page + 1, newPages.length - 1);
      setPage(newPage);
      var location = window && window.location ? window.location.pathname : '/';
      var search = query_string_1.default.parse(window.location.search);
      console.info('search', search);

      if (search) {
        search.page = String(newPage);
      }

      location += "?".concat(query_string_1.default.stringify(search));
      window.history.replaceState({
        location: location,
        page: newPage
      }, "page ".concat(newPage), location);
    }
  };

  var newDatas = [];

  if (newPages) {
    newPages.forEach(function (_ref7) {
      var datas = _ref7.datas;
      var tmpDatas = datas && !Array.isArray(datas) ? [datas] : datas;

      if (tmpDatas) {
        newDatas = [].concat(_toConsumableArray(newDatas), _toConsumableArray(tmpDatas));
      }
    });
  }

  var initialValues = (0, initializeValues_1.default)(newDatas);
  var newBackProps = backProps !== null && backProps !== void 0 ? backProps : {};
  newBackProps.onClick = page > 0 ? handleBackOnClick : undefined;
  return react_1.default.createElement(WizardSC, {
    as: sc && sc.wizard,
    className: className
  }, showProgress && newPages && react_1.default.createElement(ProgressBar_1.default, _objectSpread(_objectSpread({}, progressProps), {}, {
    handleStepButtonOnClick: handleStepButtonOnClick,
    iconStep: sc && sc.iconStep,
    iconSuccess: sc && sc.iconSuccess,
    infos: infos,
    itemIconProps: progressItemIconProps,
    itemProps: progressItemProps,
    page: page,
    pages: newPages,
    showStep: progressShowStep
  })), newPages && newPages.length > page && react_1.default.createElement(Form_1.default, _objectSpread(_objectSpread({
    cancelProps: newBackProps,
    id: "".concat(id, "--page_").concat(page),
    initialValues: initialValues,
    onSubmit: handleNextOnClick
  }, newPages[page]), {}, {
    destroyOnUnmount: false,
    forceUnregisterOnUnmount // <------ unregister fields on unmount
    : true,
    name: name,
    params: params
  })));
};

exports.default = Wizard;